import React, { AnchorHTMLAttributes, ReactElement } from 'react';
import { LinkWrapper } from '../../components/LinkWrapper/LinkWrapper';
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';
import { wrapTrademarkSuperscript } from '../cob-utils';


export const rewriteLink = (input: ReactElement): ReactElement => {
    let newProps: any;
    if (input.type && input.props && input.props.children && input.props.children.length) {
        const newChildren = input.props.children.map((el: ReactElement) => {
            return rewriteLink(el);
        });

        newProps = {
            ...input.props,
            children: newChildren,
        };

        if (input.type === 'a') {
            return <LinkWrapper {...newProps} />;
        }
        return <input.type {...newProps} />;
    }

    return input;
};

export const rewriteContent = (content: ReactElement[]): ReactElement[] => {
    const updatedContent = content.map((el) => {
        return rewriteLink(el);
    });
    return updatedContent;
};

/**
 * Takes any string containing html (i.e. props.description, etc...) and transforms all
 * 'a' tags to be LinkWrappers.
 * LinkWrapper is necessary for handling external link and speedbumps.
 * @param string
 */
export const transformHTMLParserLinks = (string: string) => {
    return ReactHtmlParser(string, {
        transform: (node, index): ReactElement => {
            if (node?.children && node?.children.length && node?.attribs && node?.name === 'a' && node.type === 'tag') {
                const reactElement = convertNodeToElement(node, index, undefined);
                const props: AnchorHTMLAttributes<HTMLAnchorElement> = reactElement.props;
                const text = node.children[0];
                return (
                    <LinkWrapper {...props}>
                        {text.data}
                    </LinkWrapper>
                );
            }
        },
    });
};

/**
 * Helper function that can be used in JSX.
 * Automatically wraps Trademarks and Superscript with their appropriate
 * 
 * Sample usage: <ParseHTML>{props.textToBeParsed}</ParseHTML>
 * 
 * @returns JSX.Element
 */
export const ParseHTML = ({children}: {children: string}) => <>{transformHTMLParserLinks(wrapTrademarkSuperscript(children))}</>